import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {CopilotChatInputPartial} from './CopilotChatInputPartial'

registerReactPartial('copilot-chat-input-partial', {
  Component: CopilotChatInputPartial,
})
